export default "__VITE_ASSET__C1Pkvj7S__"